module.exports = __webpack_public_path__ + "img/userPhRes_a.f772c4bc.png";